import {combineReducers} from 'redux';
import {jobCompetencySearch} from './job-competency-search';

export const jobWizard = combineReducers({
    jobCompetencySearch,
});
